"use client";

import React from "react";
import { CircleCheck, CircleAlert, Clock, ShieldCheck } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ProductivityIncrease() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="povećanje-produktivnosti" className="bg-background py-24 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          
          {}
          <div ref={textRef} className={`transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
            <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold text-foreground leading-tight">
              Uštedite vrijeme, uštedite novac, <span className="text-primary">povećajte produktivnost</span>
            </h2>
            <p className="mt-6 text-lg text-muted-foreground leading-relaxed">Mobileo softver izgrađen je kako bi uštedio vrijeme menadžmenta, poboljšao produktivnost i performanse mobilne radne snage te pomogao vašim zaposlenicima da brže, bolje i učinkovitije obavljaju svoje svakodnevne zadatke pod jednom digitalnom platformom.</p>
            
            <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div className="flex items-start gap-4">
                <div className="bg-primary/10 p-3 rounded-lg shrink-0">
                  <Clock className="w-6 h-6 text-primary" />
                </div>
                <div>
                  <h3 className="font-default font-semibold text-foreground text-lg">Ušteda vremena</h3>
                  <p className="text-sm text-muted-foreground mt-1">Automatizirajte rutinske zadatke i izvještaje.</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="bg-primary/10 p-3 rounded-lg shrink-0">
                  <ShieldCheck className="w-6 h-6 text-primary" />
                </div>
                <div>
                  <h3 className="font-default font-semibold text-foreground text-lg">Veća učinkovitost</h3>
                  <p className="text-sm text-muted-foreground mt-1">Sve operacije na jednoj platformi.</p>
                </div>
              </div>
            </div>
          </div>

          {}
          <div ref={imageRef} className={`relative transition-all duration-1000 delay-200 ease-out ${isImageVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            {}
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-border/50 aspect-[4/3] lg:aspect-auto lg:h-[600px]">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670497/img/productivity_manager_tablet.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670497/img/productivity_manager_tablet.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670497/img/productivity_manager_tablet.png-wvc-sizes" alt="Menadžer koristi tablet za upravljanje zadacima" className="w-full h-full object-cover" loading="lazy" />
              {}
              <div className="absolute inset-0 bg-gradient-to-tr from-background/20 to-transparent pointer-events-none"></div>
            </div>

            {}
            <Card className="absolute -right-6 top-12 w-64 shadow-xl border-border/50 bg-card/95 backdrop-blur-sm hidden md:block animate-[bounce_4s_infinite_alternate]">
              <CardContent className="p-4">
                <h4 className="font-default text-sm font-semibold text-foreground mb-3 flex items-center gap-2">
                  <CircleCheck className="w-4 h-4 text-primary" />
                  Završeni obilasci
                </h4>
                <div className="space-y-3">
                  {[{
                  task: "Sjeverni ulaz - Provjera",
                  time: "10:45"
                }, {
                  task: "Glavno skladište",
                  time: "11:15"
                }, {
                  task: "Parking zona B",
                  time: "11:30"
                }].map((item, i) => <div key={i} data-index={i} className="flex items-center justify-between text-sm">
                      <div className="flex items-center gap-2">
                        <div className="w-1.5 h-1.5 rounded-md bg-primary"></div>
                        <span className="text-muted-foreground">{item.task}</span>
                      </div>
                      <span className="text-xs font-medium text-foreground">{item.time}</span>
                    </div>)}
                </div>
              </CardContent>
            </Card>

            {}
            <Card className="absolute -left-8 bottom-24 w-72 shadow-xl border-border/50 bg-card/95 backdrop-blur-sm hidden md:block animate-[bounce_5s_infinite_alternate-reverse]">
              <CardContent className="p-4">
                <h4 className="font-default text-sm font-semibold text-foreground mb-3 flex items-center gap-2">
                  <CircleAlert className="w-4 h-4 text-secondary" />
                  Upozorenja sustava
                </h4>
                <div className="space-y-3">
                  <div className="flex items-start gap-3 p-2 rounded-lg bg-secondary/10 border border-secondary/20">
                    <CircleAlert className="w-5 h-5 text-secondary shrink-0 mt-0.5" />
                    <div>
                      <p className="text-sm font-medium text-foreground">Propuštena kontrolna točka</p>
                      <p className="text-xs text-muted-foreground mt-1">Sektor C, Točka 4 nije skenirana u predviđenom vremenu.</p>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>

            {}
            <div className="absolute -z-10 top-1/2 right-1/2 w-64 h-64 bg-primary/20 rounded-lg blur-3xl transform translate-x-1/2 -translate-y-1/2"></div>
            <div className="absolute -z-10 bottom-0 left-0 w-48 h-48 bg-secondary/20 rounded-lg blur-3xl transform -translate-x-1/2 translate-y-1/2"></div>
          </div>

        </div>
      </div>
    </section>;
}